import { VersionsStateShape, RootStateShape } from 'store';
import { GetterTree } from 'vuex';

export default {
	getCurrentVersion(state: VersionsStateShape, getters: any) {
		return getters.getVersion(state.current);
	},

	getCurrentVersionLabel(state: VersionsStateShape, getters: any) {
		return getters.getCurrentVersion.text;
	},

	getVersion: (state: VersionsStateShape) => (id: string) => {
		const version = state.versions[id];

		return version ? version : new Error(`version with provided id doesn't exist`);
	}
} as GetterTree<VersionsStateShape, RootStateShape>;
